import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Tv } from 'lucide-react';
import toast from 'react-hot-toast';
import PosterGrid from '@components/streamflow/PosterGrid';
import type { Channel } from '@lib/streamFlowApi';

/**
 * /series — TV show browse surface.
 *
 * Currently a stub for playback: clicking a series tile shows a "details
 * coming soon" toast. The episode picker (fetches
 * /player_api.php?action=get_series_info on demand, lists seasons and
 * episodes, plays each via /series/<u>/<p>/<episodeId>) is the next
 * iteration — gates the more involved episode-level data model.
 *
 * The listing path is intentionally identical to /movies so users have
 * a consistent browse pattern; only the click action differs.
 */
export default function Series() {
  const navigate = useNavigate();

  const onPlay = (channel: Channel) => {
    // Phase-7 follow-up: episode picker. For now, hint at what's coming
    // and surface the underlying channel id for debugging.
    toast(`Episode picker coming soon — "${channel.name}"`, {
      icon: '📺',
      duration: 3500,
    });
  };

  return (
    <div className="max-w-6xl mx-auto px-4 py-6">
      <button
        onClick={() => navigate('/')}
        className="flex items-center gap-2 text-sm text-gray-600 hover:text-gray-900 mb-4"
      >
        <ArrowLeft className="w-4 h-4" />
        Back to Dashboard
      </button>

      <div className="flex items-center gap-2 mb-4">
        <Tv className="w-6 h-6 text-slate-800" />
        <h1 className="text-2xl font-bold">Series</h1>
      </div>

      <PosterGrid kind="series" onPlay={onPlay} />
    </div>
  );
}
